import styled, { css } from 'styled-components';
import { Brand } from '@/domainLogic/index.ts';
import { FILTERS_HEIGHT, HEADER_HEIGHT, SEARCH_WIDGET_HEIGHT } from '@/app/common/constants.ts';
import { filters } from '../../../verticalFilters/filters';
import type { Localization } from '../../../../../common/Localization';
import { sortOption, sortOverlayStyles } from '../styled';
import { FilledButton, plainButton } from '../../../../../styles/buttons';
import { focusRing, hideScrollbar } from '../../../../../styles/mixins';
import { maxHeightOfOverlay } from './utils.ts';

export const PillOverlayContainer = styled.div<{
  localization: Localization;
  brand: Brand;
  columns?: number;
  hasScroll: boolean;
  ref: React.MutableRefObject<HTMLDivElement | undefined>;
  externalHeaderEnabled: boolean;
}>`
  width: 300px;
  background-color: #fff;
  position: fixed;
  border-radius: 16px;
  top: 122px;
  transition: top 0.35s ease-out;
  left: 0;
  box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.largeDownShadow};
  z-index: 3;
  padding: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${filters};

  ${({ externalHeaderEnabled, brand }) =>
    externalHeaderEnabled &&
    css`
      top: ${
        HEADER_HEIGHT(brand, true) + SEARCH_WIDGET_HEIGHT + FILTERS_HEIGHT - (brand === Brand.HOLIDAYPIRATES ? 14 : 5)
      }px;
    `}

  &.pill-overlay-container {
    left: unset !important;
    right: 8px !important;
  }

  &:has(.multilistbox) {
    padding-top: 4px;
  }

  ${({ columns }) =>
    columns === 2 &&
    css`
      width: 660px;
    `}

  ${maxHeightOfOverlay};

  :focus-visible:not(.csw-portal *) {
    ${focusRing}
  }

  .openx-ui-sort-modal label:focus-visible {
    border-radius: 2px;
  }

  @media (max-width: 767px) {
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
    padding: 0;
    border-radius: 16px 16px 0 0;
    overflow: hidden;
    max-height: calc(100vh - 32px);
  }

  .oss-ui-form {
    width: 100%;
    overflow: auto;

    @media (max-width: 767px) {
      width: calc(100% - 32px);
      background-color: #fff;
      padding: 16px;
      margin: 16px 0;
      border-radius: 8px;
      max-height: calc(100vh - 195px);
      overflow-y: scroll;
      ${hideScrollbar};
    }

    &.openx-ui-filters-overlay {
      overflow: auto;
      ${hideScrollbar};
    }
  }

  label {
    display: none;
  }

  &.MealContainer label {
    display: flex;
  }

  &.SortContainer {
    ${sortOverlayStyles};

    .openx-ui-sort-modal {
      padding: 16px;
      ${sortOption};
      label {
        height: auto;
        min-height: 48px;
      }
      > div {
        border-radius: 8px;
        &:first-of-type {
          height: auto;
        }
      }
    }
  }
  &.PriceContainer {
    .oss-ui-form {
      width: 100%;
    }
  }

  //styles to fix cut focus ring

  &.PropertyTypeContainer,
  &.StarsContainer,
  &.RatingContainer,
  &.FacilitiesContainer,
  &.PriceContainer {
    padding-left: 12px;

    .openx-ui-filters-overlay {
      padding-left: 4px;
    }
  }

  &.MealContainer {
    padding-left: 12px;
    padding-right: 12px;

    .openx-ui-filters-overlay {
      padding-left: 4px;
      padding-right: 4px;
    }
  }
`;

export const Clear = styled(plainButton)<{ disabled: boolean }>`
  margin-right: 16px;
`;

export const Apply = styled(FilledButton)<{ disabled: boolean }>``;

export const CtaContainer = styled.div<{ fixedBottom?: boolean }>`
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 16px;

  @media (max-width: 767px) {
    box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.mediumDownShadow};
    padding: 16px;
  }

  ${({ fixedBottom }) =>
    fixedBottom &&
    css`
      box-shadow: ${({ theme }): string => theme?.kallisto?.shadow?.mediumDownShadow};
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 16px;
      z-index: 1;
      border-radius: 0 0 16px 16px;
    `}
`;
